// @flow

import React, {Component} from 'react'
import {map} from 'ramda'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import type {Language} from '@/types'
import FaShare from 'react-icons/lib/fa/share-alt'

import './dropdown-selector.css'

type Props = {
  label: string,
  selected: ?string,
  options: Array<Object>,
  onChange: (string) => void,
  disable?: boolean,
  l: Language,
  activeId: ?number,
  activeTab: string,
  defaultText: ?string,
  isShared: boolean,
}

const initialState = {
  isOpen: false,
}

type State = {
  isOpen: boolean,
}

const renderOption = (onSelectPortfolio, l) => ({key, value, disabled, isShared, isAllPortfolio}) => <div key={key}>
  <li key={key} value={key} disabled={disabled} onClick={onSelectPortfolio}>
    {isAllPortfolio ? l(value) : value}
    {isShared ? <div className='share-icon'><FaShare /></div> : null}
  </li>
  {isAllPortfolio && <hr className='line-breaker'/>}
</div>

export class RawDropdownSelector extends Component<Props, State> {
  node: ?any
  constructor (props: Props) {
    super(props)
    this.state = initialState
  }

  selectPortfolio = (e: any) => {
    const val = e.currentTarget.value
    if (val !== this.props.activeId) {
      this.props.onChange(String(val))
    }
  }

  attachEventListenerToDocument = () => {
    document.addEventListener('click', this.handleOutsideClick)
  }

  removeEventListenerToDocument = () => {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  toggleDropdown = () => {
    const val = this.state.isOpen
    this.setState({isOpen: !val}, () => {
      if (!val) {
        this.attachEventListenerToDocument()
      } else {
        this.removeEventListenerToDocument()
      }
    })
  }

  handleOutsideClick = (e: any) => {
    if (this.node && !this.node.contains(e.target)) {
      this.setState({isOpen: false})
    } else {
      this.setState({isOpen: true})
    }
  }
  render = () =>
    <label>{this.props.l(this.props.label)}
      <div ref = {(elem) => { this.node = elem }}>
        <button className="btn btn-default custom-dropdown-toggle" type="button" disabled={this.props.disable}
          onClick={this.toggleDropdown}>
          <div className='selected-portfolio truncate'>{this.props.selected || this.props.l(this.props.defaultText) || this.props.l('Select')}</div>
          <div className="caret pull-right"></div>
          {this.props.isShared ? <span className='share-icon pull-right'><FaShare /></span> : null}
        </button>
        <ul className="custom-dropdown-menu"
          style={{'display': this.state.isOpen ? 'block' : 'none'}}>
          {map(renderOption(this.selectPortfolio, this.props.l), this.props.options)}
        </ul>
      </div>
    </label>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  activeTab: state.ui.activeTab,
})

export default connect(
  mapStateToProps, null
)(RawDropdownSelector)



// WEBPACK FOOTER //
// ./src/controls/dropdown-selector.js